import React from 'react';
import { bool, func, object, string } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { ensureOwnListing } from '../../util/data';
import { LISTING_STATE_DRAFT } from '../../util/types';
import { ListingLink } from '../../components';
import { EditListingSuccessFactorsForm } from '../../forms';

import css from './EditListingSuccessFactorsPanel.module.css';

const EditListingSuccessFactorsPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureOwnListing(listing);
  const {
    publicData: {
      hasCompletedAssessment,
      isReportAvailable,
      isBoldlyArrange,
      briefingAndDebriefing,
      coacheesDirectManager,
      managersEmail,
    }
  } = currentListing.attributes;

  const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
  const panelTitle = isPublished ? (
    <FormattedMessage
      id="EditListingSuccessFactorsPanel.title"
      values={{ listingTitle: <ListingLink listing={listing} /> }}
    />
  ) : (
    <FormattedMessage id="EditListingSuccessFactorsPanel.createListingTitle" />
  );

  return (
    <div className={classes}>
      <h1 className={css.title}>{panelTitle}</h1>
      <h3 className={css.subTitle}>
        <FormattedMessage
          id="EditListingSuccessFactorsPanel.subTitle"
        />
      </h3>
      <EditListingSuccessFactorsForm
        className={css.form}
        initialValues={{
          hasCompletedAssessment,
          isReportAvailable,
          isBoldlyArrange,
          briefingAndDebriefing,
          coacheesDirectManager,
          managersEmail,
        }}
        saveActionMsg={submitButtonText}
        onSubmit={values => {
          const {
            hasCompletedAssessment,
            isReportAvailable,
            isBoldlyArrange,
            briefingAndDebriefing,
            coacheesDirectManager,
            managersEmail,
          } = values;
          const updateValues = {
            publicData: {
              hasCompletedAssessment,
              isReportAvailable,
              isBoldlyArrange,
              briefingAndDebriefing,
              coacheesDirectManager,
              managersEmail,
            },
          };

          onSubmit(updateValues);
        }}
        onChange={onChange}
        disabled={disabled}
        ready={ready}
        updated={panelUpdated}
        updateInProgress={updateInProgress}
        fetchErrors={errors}
      />
    </div>
  );
};

EditListingSuccessFactorsPanel.defaultProps = {
  className: null,
  rootClassName: null,
  errors: null,
  listing: null,
};

EditListingSuccessFactorsPanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingSuccessFactorsPanel;
